<div class="py-3 mb-8">
    <div class="flex flex-wrap gap-2">
        @if (!utilityService.cameraPermissionStatus?.granted) {
            <p-message severity="warn">Need camera permission to capture photo and upload. &nbsp;<a style="text-decoration: underline; color:#a16207; cursor: pointer;" (click)="utilityService.requestCameraPermission()">Grant Permission</a></p-message>
        }
        @for (image of images; track $index; let i = $index) {
            <div class="relative">
                <p-button
                    class="absolute top-2 right-2 z-10"
                    icon="pi pi-trash" 
                    severity="danger"
                    [outlined]="false"
                    (click)="deleteImage(i)" />
                <p-image [src]="image.downloadUrl" alt="Image" width="200" height="200" [preview]="true" />
            </div>
        }
        @if(images.length < 2) {
            <p-fileupload 
                #fileupload 
                [style]="{'background-color': 'aliceblue', 'color':'black', 'height': '100%', 'width': '200px', 'min-height': '200px'}" 
                severity="secondary" 
                class="flex" 
                mode="basic" 
                name="image" 
                chooseIcon="pi pi-upload" 
                [customUpload]="true" 
                [multiple]="true" 
                accept="image/*" 
                (uploadHandler)="uploadProofOfDeliveryImage($event, fileupload)" 
                [auto]="true" 
                chooseLabel="Upload" />
        }
    </div>

    <div class="absolute z-10 bottom-0 right-0 left-0 h-12 w-full bg-green-100">
        <div>
            <p-button
                [label]="'Confirm Proof Of Delivery'"
                [text]="true"
                [size]="'large'"
                severity="success"
                (click)="close()"
                [disabled]="!images.length"
                [style]="{background: '#4D7935', width: '100%', 'border-radius': '0'}"
                class="[&_button]:text-white [&_button]:w-full [&_.p-button-icon]:text-md" />
        </div>
    </div>
    
</div>